import React, { useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Divider, Box, Drawer, Tooltip, Stack, IconButton } from '@mui/material';
import { deepPurple } from '@mui/material/colors';
import WindowTiles from '../WindowTiles';
import CloseIcon from '@mui/icons-material/Close';
import GridViewIcon from '@mui/icons-material/GridView';

const ProductionDetails = ({ production, onClose }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [openWindowTiles, setOpenWindowTiles] = useState(null);

    const handleOpenWindowTiles = () => {
        setOpenWindowTiles(true);
        setEditId(production?.id);
        setIsDrawerOpen(true);
    }

    const closeDrawer = () => {
        setOpenWindowTiles(null);
        setIsDrawerOpen(false);
    };

    if (!production)
        return <Typography variant="h6">Select a client to view details</Typography>;

    const tableHeaders = [
        { label: 'Field', width: '30%' },
        { label: 'Value', width: '70%' },
    ];

    const tableData = [
        // { field: 'id', value: production?.id },
        { field: 'Περιγραφή', value: production?.p_descr },
        { field: 'Αριθμός επεισοδίων', value: production?.no_of_episodes },
        { field: 'Επεισόδια ανά εγγραφή (σχεδιασμός)', value: production?.episodes_per_recording ?? '-' },
        { field: 'Διάρκεια επεισοδίου (λεπτά)', value: production?.episode_duration },
        { field: 'AA', value: production?.p_aa },
    ];

    return (
        <Paper elevation={3} sx={{ padding: 2, borderRadius: 2, backgroundColor: '#f4f6f8', height: '100%' }}>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                <Typography variant="h3">Λεπτομέρειες</Typography>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Stack>

            <Divider />

            <Tooltip title="View Details">
                <IconButton color="primary" onClick={handleOpenWindowTiles}>
                    <GridViewIcon />
                </IconButton>
            </Tooltip>

            <Divider />

            <TableContainer component={Box}>
                <Table>
                    <TableBody>
                        {tableData.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ color: '#757575', backgroundColor: index % 2 ? '#fafafa' : '#ffffff' }}>{row.field}</TableCell>
                                <TableCell sx={{ color: '#757575', backgroundColor: index % 2 ? '#fafafa' : '#ffffff' }}>{row.value}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Drawer
                anchor="right"
                open={isDrawerOpen}
                onClose={closeDrawer}
            >

                {editId && openWindowTiles && <WindowTiles
                    production={production}
                    // clientId={editId}
                    onClose={closeDrawer}
                />}

            </Drawer>

        </Paper>
    );
};

export default ProductionDetails;